import React from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

const AgreementTemplatesLayout = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const isTenant = location.pathname.includes("/agreement-templates/tenant");
	const tab = isTenant ? "tenant" : "landlord";

	return (
		<Box>
			<Tabs
				value={tab}
				onChange={(_, value) =>
					navigate(value === "tenant" ? "/agreement-templates/tenant" : "/agreement-templates")
				}
				sx={{ mb: 2, borderBottom: 1, borderColor: "divider" }}
			>
				<Tab value="landlord" label="Landlord onboarding" />
				<Tab value="tenant" label="Tenant onboarding" />
			</Tabs>
			<Outlet />
		</Box>
	);
};

export default AgreementTemplatesLayout;
